<script lang="ts">
	import { ButtonArrowPrimary } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';
	import { urls } from '@app/urls';
	import type { NewsFeedCommonModel } from '@app/models/api/NewsFeed';
	import { getNewsLatestOperationName } from '@app/models/api/NewsFeed';
	import { NewsFeedTypeItem } from '@app/models/api/enums/NewsFeedTypeItem';
	import { isSidebarOpen } from '@app/stores/sidebar';
	import UserNavNotificationsListItem from '@app/components/nav/userNav/UserNavNotificationsListItem.svelte';
	import {
		unreadNewsfeedItems,
		unreadNotifications,
		userAccountNotifications
	} from '@app/stores/notifications';

	export let nbShown: number;
	export let onClickButtonFunction: () => void;

	const getNotificationTitle = (notif: NewsFeedCommonModel): string => {
		return notif.type === NewsFeedTypeItem.ASSEMBLIES
			? getNewsLatestOperationName(notif)
			: notif.type === NewsFeedTypeItem.WEATHER
				? notif.targetName
				: notif.title;
	};
	const getNotificationDesc = (notif: NewsFeedCommonModel): string => {
		return notif.type === NewsFeedTypeItem.ASSEMBLIES
			? notif.title
			: notif.type === NewsFeedTypeItem.WEATHER
				? $t('newsFeed.meteo.notificationTitle')
				: '';
	};
</script>

{#if $userAccountNotifications && $unreadNotifications > 0}
	<ul
		class="divide-y divide-grey-light p-0 lg:w-[400px] lg:max-h-[500px] {$unreadNewsfeedItems.length -
			nbShown >
			0 || $userAccountNotifications?.length > nbShown
			? 'overflow-scroll before:hidden before:lg:block before:absolute before:bottom-3 before:left-[1px] before:w-[calc(100%-2px)] before:h-5 before:bg-gradient-to-t before:from-white to-transparent'
			: ''}"
	>
		{#each $userAccountNotifications as props}
			<UserNavNotificationsListItem {props} />
		{/each}
		{#each $unreadNewsfeedItems as notif, index}
			{#if !nbShown || index < nbShown}
				<UserNavNotificationsListItem
					props={{
						title: getNotificationTitle(notif),
						desc: getNotificationDesc(notif),
						imageUrl: { title: notif?.title, url: notif?.logoUrl },
						linkUrl: urls.NEWS_FEED,
						linkLabel: $t('readMore')
					}}
				/>
			{/if}
		{/each}
		{#if $unreadNewsfeedItems.length - nbShown > 0}
			<li
				data-sveltekit-preload-data="tap"
				data-sveltekit-preload-code="hover"
				class="font-semibold text-grey-dark text-sm py-3 flex mb-3 justify-between items-center"
			>
				<div>
					{$t('newsFeed.others', { values: { value: $unreadNewsfeedItems.length - nbShown } })}
				</div>
				<ButtonArrowPrimary
					props={{ label: $t('see'), href: urls.NEWS_FEED, classNames: 'cursor-pointer' }}
					on:click={() => {
						onClickButtonFunction && onClickButtonFunction();
						$isSidebarOpen = false;
					}}
				/>
			</li>
		{/if}
	</ul>
{:else}
	{$t('newsFeed.noUnreadNotifications')}
{/if}
